import { render, staticRenderFns } from "./StorerBaseData.vue?vue&type=template&id=7d736d20"
import script from "./StorerBaseData.vue?vue&type=script&lang=js"
export * from "./StorerBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports